'use client'

import { trackViewDetailsClick } from '@components/app/TrialSummaryCard/trackViewDetailsClick'
import Link, { type LinkProps } from '@components/primitives/Link'
import { TrackingSources } from '@lib/tracking/TrackingSources'
import type { ReactElement } from 'react'

/** Client component taking in a child so we can server render the children and make sure they are in the DOM */
export default function TrialLinkWrapper({
  children,
  href,
  onClick,
  trackingSource,
  ...linkProps
}: {
  children: ReactElement
  href: string
  onClick?: () => void
  trackingSource?: TrackingSources
} & LinkProps) {
  const handleOnClick = () => {
    trackViewDetailsClick(
      href,
      trackingSource ? trackingSource : TrackingSources.DIRECTORY,
    )
    onClick?.()
  }

  return (
    <Link {...linkProps} href={href} onClick={handleOnClick}>
      {children}
    </Link>
  )
}
